/**
 *
 * @description
 * lab result details componet
 * fetching data based on billid
 * @author Jinishakappil
 *
 */

import React, { useState, useEffect, useContext } from 'react';

import { Tag, Table, Select, Skeleton, Tooltip, Input, Radio, Form, Col, Row, Collapse } from 'antd';

import ToolTipWrapper from '../../../components/tooltip-wrapper/tooltip-wrapper';

import './lab-result-doctor-notes.scss';

import { Samples, ServiceResultMaster } from '../../../models';

import { useTranslation, Card, TableComponent } from 'soxo-bootstrap-core';
import DisplayLabParameter, { GetLabResultClass } from '../display-lab-parameter/display-lab-parameter';
const { Panel } = Collapse;
const { Option } = Select;
const formItemLayout = {
    layout: 'vertical',
};
export default function DoctorNotesLabResult({ mode = 'bill', bill_id, initialValues, callback, onFieldChange, ...props }) {
    const [labReportResult, setLabReportResult] = useState({ test: {}, result: {}, entries: [], index: null });
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation(); // To Translate to another language
    const [filter, setFilter] = useState('abnormal'); // 'all', 'normal', 'abnormal'
    // const [originalLabReportResult, setOriginalLabReportResult] = useState({});
    const [status, setStatus] = useState();
    const [tableData, setTableData] = useState();
    // 'all', 'normal', 'abnormal
    const [selectedFilter, setSelectedFilter] = useState('all');

    // Define an asynchronous function to handle data fetching
    useEffect(async () => {
        await getLabResultByBillid(bill_id);

        // Check if the component should be displayed and if initial values are available
        if (props.isDisplayed && initialValues) {
            await getLabstatus();

            // Set form fields with the retrieved initial values
            form.setFieldsValue({ lab_followup_remark: initialValues.lab_followup_remark, lab_followup_status: initialValues.lab_followup_status });
            // Apply the selected filter to the lab results
            await applySelectedFilter('abnormal', initialValues.lab_result);
        }
    }, []);

    /**
     * This Api is used in doctor notes screen .
     * used to load lab resultsbased on bill id
     *
     */
    function getLabResultByBillid() {
        setLoading(true);
        Samples.getLabReportResultByBillId(bill_id).then(async (result) => {
            let arr = [];

            result.data.forEach((ele) => {
                let index = 0; // Initialize index for each lab_test array
                // pushing lab result to an array
                arr.push({ title: true, result: ele.lab_test });
                ele.lab_test.parameters &&
                    ele.lab_test.parameters.forEach((value) => {
                        // recording parameter and its index to array
                        if (value && value.value !== '') {
                            index = index + 1; // Increment index
                            arr.push({ value: value, index: index });
                        }
                    });
            });

            // set array to the state
            setLabReportResult(arr);
            // setOriginalLabReportResult(arr);

            setLoading(false);
        });
    }

    // function labColoringClass(ele) {
    //     let resultClassName = '';

    //     /* Ensure that ele.value and ele.value.value are defined */
    //     let rawValue = ele.value && ele.value.value !== undefined ? ele.value.value : '';

    //     /* Check if rawValue is not an empty string */
    //     let value = rawValue !== '' ? rawValue : '';

    //     /* Convert value to a numeric representation if it's not an empty string */
    //     let numericValue = rawValue !== '' ? parseFloat(value) : null;
    //     /** If the result value is zero or if both the lower bound (lbound) and upper bound (ubound) become -1, then there is no need for any color */
    //     // Check if numericValue is 0 or if both lower and upper bounds are -1
    //     // console.log("QQQQQQQQQ",ele.value.ubound === null && ele.value.ubound === -1 && numericValue < ele.value.refmin)
    //     if (ele.value?.reftype?.toUpperCase() === 'NUMERIC') {
    //         if (ele.value?.lbound === -1 && ele.value?.ubound === -1) {
    //             // Check if refmin and refmax are not -1, and numericValue is within the range of refmin and refmax
    //             if (ele.value.refmin !== -1 && ele.value.refmax !== -1 && numericValue >= ele.value.refmin && numericValue <= ele.value.refmax) {
    //                 // If all conditions are met, set result class name to 'normal
    //                 resultClassName = 'normal';
    //             } else {
    //                 // If conditions aren't met, set result class name to 'warning'

    //                 // resultClassName = '';
    //                 resultClassName =
    //                     ele.value.refmin !== -1 && ele.value.refmax !== -1 && !(numericValue >= ele.value.refmin && numericValue <= ele.value.refmax)
    //                         ? 'warning'
    //                         : '';
    //             }
    //         } else if (numericValue !== null && !isNaN(numericValue)) {
    //             /* Check for abnormal values */
    //             if (ele.value.refmin !== -1 && ele.value.refmax !== -1 && numericValue >= ele.value.refmin && numericValue <= ele.value.refmax) {
    //                 /* Check for normal values */
    //                 resultClassName = 'normal';
    //             } else if (
    //                 ele.value.refmin !== -1 &&
    //                 ele.value.refmax !== -1 &&
    //                 ((numericValue < ele.value.refmin && numericValue >= ele.value.lbound) ||
    //                     (numericValue > ele.value.refmax && numericValue <= ele.value.ubound))
    //             ) {
    //                 /* Check for warning values */
    //                 resultClassName = 'warning';
    //             } else if (
    //                 ele.value.refmin === -1 &&
    //                 ele.value.refmax === -1 &&
    //                 numericValue >= ele.value.lbound &&
    //                 numericValue <= ele.value.ubound
    //             ) {
    //                 /* Check for normal values without refmin and refmax*/
    //                 resultClassName = 'normal';
    //             } else if ((ele.value.ubound == null || ele.value.ubound == -1) && numericValue > ele.value.refmax) {
    //                 resultClassName = 'warning';
    //             } else if ((ele.value.lbound == null || ele.value.lbound == -1) && numericValue < ele.value.refmin) {
    //                 resultClassName = 'warning';
    //             } else if (
    //                 (ele.value.lbound !== 0 || ele.value.ubound !== 0) &&
    //                 ((ele.value.lbound !== 0 && numericValue < ele.value.lbound) || (ele.value.ubound !== 0 && numericValue > ele.value.ubound))
    //             ) {
    //                 resultClassName = 'abnormal';
    //             }
    //         } else {
    //             /* Add an else block to handle the case where none of the conditions are met*/
    //             resultClassName = '';
    //         }
    //     } else {
    //         resultClassName = '';
    //     }
    //     return resultClassName;
    // }

    /**
     * function to fetch lab status options
     * */
    async function getLabstatus() {
        // Fetch service result master data based on category and mode_status props
        let result = await ServiceResultMaster.getServiceResultMaster(props.category, props.mode_status);
        // Filter the result to include only active records (where active is 'Y')

        var dropdown = result.data.filter((record) => record.active === 'Y');
        // Update the state with the filtered dropdown values

        setStatus(dropdown);
    }

    /**
     * Filters the lab results based on the selected filter and updates the state with the filtered data.
     *
     * @param {string} selectedFilter - The filter that has been selected to apply on the lab results.
     * @param {Array} labResultData - The array of lab results to be filtered.
     *
     * The function checks if there are any lab results, filters them based on the selected filter,
     * and then updates the state with the filtered results.
     */

    async function applySelectedFilter(selectedFilter, labrecord) {
        if (!labrecord?.length) return; // Return early if there's no data

        let filteredData = labrecord.filter((ele) =>
            selectedFilter === 'abnormal' ? ele.score === 'C' || ele.score === 'D' : ele.score === 'A' || ele.score === 'B'
        );

        setTableData(filteredData);
    }
    const labResultColumns = [
        {
            title: '#',
            align: 'center',
            render: (value, item, index) => {
                return value.title ? null : value.index;
            },
        },
        {
            title: t('Particulars'),
            render: (ele, value) => {
                return value.title ? (
                    <small>
                        <strong>{value.result.test_name}</strong>
                        {(value.result.test_status === 'pending' ||
                            (value.result.test_status === 'done' &&
                                (value.result.parameters || []).every(
                                    (param) =>
                                        param.value === '' ||
                                        param.value === null ||
                                        param.value === undefined ||
                                        (typeof param.value === 'string' && param.value.trim() === '')
                                ))) && (
                            <Tag color="blue" style={{ marginLeft: '20px' }}>
                                {t('Pending')}
                            </Tag>
                        )}

                        {/* Authorized / Unauthorized */}
                        {value.result.is_closed === 'N'&&  (
                                <Tag color="red" style={{ marginLeft: '10px' }}>
                                    {t('Unauthorized')}
                                </Tag>
                            )}
                        {value.result.is_closed === 'Y' && (
                            <Tag color="green" style={{ marginLeft: '10px' }}>
                                {t('Authorized')}
                            </Tag>
                        )}
                    </small>
                ) : (
                    ele?.value?.particulars || ele.particulars
                );
            },
        },
        {
            title: t('Result'),
            key: 'result',
            render: (ele) => {
                /* Ensure that ele.value and ele.value.value are defined */
                let rawValue = ele.value && ele.value.value !== undefined ? ele.value.value : '';
                /* Check if rawValue is not an empty string */
                let value = rawValue !== '' ? rawValue : '';
                return <DisplayLabParameter value={ele}></DisplayLabParameter>;
            },
        },
        {
            title: t('Ref.Range'),
            key: 'range',
            render: (ele) => {
                //
                return ele.title ? null : <ToolTipWrapper content={ele.value.reference_range} length={15} />;
            },
        },
        {
            title: t('Unit'),
            key: 'unit',
            render: (ele) => {
                return ele.title ? null : <ToolTipWrapper content={ele.value.unit} length={10} />;
            },
        },
    ];

    /**
     * Filters and groups lab report results based on the selected filter type.
     *
     * The `labReportResult` is expected to be an array of items, grouped by test sections.
     * Each group starts with a `title` row (the group header), followed by parameter rows.
     *
     * Filtering is controlled by the value of `selectedFilter`:
     *
     * Rules:
     * - For `selectedFilter = 'pending'`:
     *     - Includes the entire group if:
     *         - The group's `test_status` is `'pending'`, OR
     *         - The group's `test_status` is `'done'` but all parameter values are empty.
     *     - Parameter values are considered empty if they are: `''`, `null`, `undefined`, or whitespace.
     *
     * - For `selectedFilter = 'normal'`:
     *     - Includes only parameter rows where `GetLabResultClass(param)` returns `'normal'`.
     *     - Group title is included only if at least one matching parameter exists.
     *
     * - For `selectedFilter = 'abnormal'`:
     *     - Includes parameter rows where `GetLabResultClass(param)` returns `'abnormal'` or `'warning'`.
     *     - Group title is included only if at least one matching parameter exists.
     *
     * - For `selectedFilter = 'all'`:
     *     - Includes the entire group (title + all parameters) without filtering.
     *
     * Behavior:
     * - Iterates through the report list and forms groups based on the presence of a `title` field.
     * - Applies filtering logic per group via `processGroup()`.
     * - Always ensures group titles are preserved if any parameter row matches the selected filter.
     *
     * Returns:
     * - A new array of filtered lab report data, preserving group structure.
     * - Returns an empty array if `labReportResult` is not a valid array.
     */

    const filteredLabReportResult = (() => {
        if (!Array.isArray(labReportResult)) return [];

        const filtered = [];
        let currentGroup = [];

        const processGroup = (group) => {
            const [groupTitle, ...params] = group;

            const isPendingGroup = (() => {
                const status = groupTitle?.result?.test_status;

                // case 1: directly pending
                const isPendingStatus = status === 'pending';

                const parameters = groupTitle?.result?.parameters || [];
                const parametersValue = parameters[0]?.value;

                const allValuesEmpty = parameters.every((param) => {
                    const value = param.value;
                    return value === '' || value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
                });

                const isDoneWithEmptyValue = status === 'done' && allValuesEmpty;

                return isPendingStatus || isDoneWithEmptyValue;
            })();

            if (selectedFilter === 'pending') {
                if (isPendingGroup) {
                    filtered.push(groupTitle, ...params);
                }
            } else {
                const filteredParams = params.filter((p) => {
                    const className = GetLabResultClass(p);
                    if (selectedFilter === 'normal') return className === 'normal';
                    if (selectedFilter === 'abnormal') return className === 'abnormal' || className === 'warning';
                    return true; // for "all"
                });

                if (selectedFilter === 'all' || filteredParams.length > 0) {
                    filtered.push(groupTitle, ...filteredParams);
                }
            }
        };

        labReportResult.forEach((item) => {
            if (item.title) {
                if (currentGroup.length > 0) {
                    processGroup(currentGroup);
                }
                currentGroup = [item]; // start new group
            } else {
                currentGroup.push(item);
            }
        });

        if (currentGroup.length > 0) {
            processGroup(currentGroup); // process last group
        }

        return filtered;
    })();
    return (
        <Card className="result-deatails lab-result-doctor-notes card card-shadow">
            <div style={{ margin: '10px 0' }}>
                <Radio.Group
                    onChange={(e) => {
                        const selectedValue = e.target.value;
                        // Handle logic here to filter based on 'all', 'abnormal', 'normal'
                        setSelectedFilter(selectedValue);
                    }}
                    defaultValue="all"
                    buttonStyle="solid"
                >
                    <Radio value="all">{t('All')}</Radio>
                    <Radio value="abnormal">{t('Abnormal')}</Radio>
                    <Radio value="normal">{t('Normal')}</Radio>
                    <Radio value="pending">{t('Pending')}</Radio>
                </Radio.Group>
            </div>
            <div>
                <div class="card-header">
                    <div className="card-title">
                        <h3>{t('LAB')}</h3>
                    </div>

                    <div className="legend-container">
                        <Legend />
                    </div>
                </div>
            </div>
            {loading ? (
                <Card className="card-shadow card">
                    <Skeleton active />
                </Card>
            ) : (
                <div>
                    {props.isDisplayed ? (
                        <div>
                            <Radio.Group
                                value={filter}
                                onChange={(e) => {
                                    const selectedFilter = e.target.value;
                                    setFilter(e.target.value);
                                    applySelectedFilter(selectedFilter, initialValues.lab_result);
                                }}
                            >
                                {/* <Radio.Button value="all">All</Radio.Button> */}
                                <Radio value="abnormal">Abnormal</Radio>
                                <Radio value="normal">Normal</Radio>
                            </Radio.Group>
                        </div>
                    ) : null}

                    <>
                        {props.isDisplayed && initialValues.lab_result ? (
                            <>
                                <CollapseModal
                                    data={tableData}
                                    status={status}
                                    onChangeValue={(value, fieldName) => {
                                        onFieldChange(value, fieldName);
                                    }}
                                ></CollapseModal>
                            </>
                        ) : (
                            <>
                                {/* <Table
                                    className="doctor-notes-lab-deatils"
                                    rowKey={(record, key) => key}
                                    pagination={false}
                                    // scroll={{ x: true }}
                                    // dataSource={labReportResult}
                                    dataSource={filteredLabReportResult}
                                    columns={labResultColumns}
                                /> */}
                                <div style={{ overflowX: 'auto', overflowY: 'auto', minHeight: '835px', height: '835px' }}>
                                    <TableComponent
                                        className="doctor-notes-lab-deatils"
                                        rowKey={(record, key) => key}
                                        pagination={false}
                                        scroll={false}
                                        // dataSource={labReportResult}
                                        dataSource={filteredLabReportResult}
                                        columns={labResultColumns}
                                    />
                                </div>
                            </>
                        )}
                    </>
                </div>
            )}
        </Card>
    );
}

/**
 *
 * @returns
 */
function Legend() {
    return (
        <>
            {[
                {
                    caption: 'Normal',
                    color: 'normal',
                },
                {
                    caption: 'Warning',
                    color: 'warning',
                },
                {
                    caption: 'Abnormal',
                    color: 'abnormal',
                },
            ].map((status) => (
                <StatusLabel status={status} />
            ))}
        </>
    );
}

/**
 *
 * @param {*} param0
 * @returns
 */
function StatusLabel({ status = {} }) {
    return (
        <div className={`status-label ${status.color}`}>
            <div className={`circle ${status.color}`}></div>

            <p>{status.caption}</p>
        </div>
    );
}

/**
 *
 * @param {*} param0
 * @returns
 */

function CollapseModal({ data, status, onChangeValue }) {
    const { t, i18n } = useTranslation(); // To Translate to another language
    const [form] = Form.useForm();

    useEffect(() => {
        const values = {};
        if (data?.length > 0) {
            data.forEach((group, index) => {
                values[`status_${index}`] = group.lab_followup_status;
                values[`remarks_${index}`] = group.lab_followup_remark;
            });
            form.setFieldsValue(values);
        }
    }, [data, form]);
    // Function to handle changes in status and remarks input field
    const handleChange = (value, ele, fieldName) => {
        ele = {
            group: ele.group,
            score: ele.score,
            item_ptr: ele.item_ptr,
        };
        onChangeValue({ ...ele, [fieldName]: value }, fieldName);
    };

    // Table column definitions for displaying lab results
    const labResultColumns = [
        {
            title: '#',
            align: 'center',
            render: (value, item, index) => {
                return index + 1;
            },
        },
        {
            title: t('Particulars'),
            render: (ele) => {
                return ele.particulars;
            },
        },
        {
            title: t('Score'),
            render: (ele) => {
                return ele.score;
            },
        },
        {
            title: t('Result'),
            key: 'result',
            render: (ele) => {
                ele.value = ele.result;
                return <DisplayLabParameter value={{ value: ele }}></DisplayLabParameter>;
            },
        },
        {
            title: t('Ref.Range'),
            key: 'range',
            render: (ele) => {
                //
                return <ToolTipWrapper content={ele.reference_range} length={15} />;
            },
        },
        {
            title: t('Unit'),
            key: 'unit',
            render: (ele) => {
                return ele.title ? null : <ToolTipWrapper content={ele.unit} length={10} />;
            },
        },
    ];
    return (
        <div className="lab-followup-section">
            {data?.length > 0 ? (
                <>
                    {data.map((group, index) => (
                        <div className="card-section" key={index}>
                            <Collapse expandIconPosition="end" style={{ backgroundColor: 'white' }}>
                                <Panel
                                    key={index}
                                    header={
                                        <Form form={form} {...formItemLayout} className="form-settings">
                                            <div className="group-section">
                                                <span style={{ fontWeight: 'bold' }}>{group.group}</span>
                                            </div>

                                            <div className="header-section">
                                                <Form.Item label="Score" style={{ marginBottom: 0, minWidth: '100px' }}>
                                                    <span style={{ color: 'red', fontWeight: 'bold' }}>{group.score}</span>
                                                </Form.Item>
                                                <Form.Item
                                                    label="Status"
                                                    name={`status_${index}`}
                                                    // initialValue={group.lab_followup_status}
                                                    style={{ marginBottom: 0, minWidth: '250px' }}
                                                >
                                                    {status && status.length ? (
                                                        <Select
                                                            style={{ width: 200, height: 24 }} // Reduce height and font size
                                                            onChange={(i, values) => {
                                                                let selectedValue = values.value;
                                                                handleChange(selectedValue, group, 'lab_followup_status');
                                                            }}
                                                        >
                                                            {status.map((option) => (
                                                                <Option value={option.code}>{option.description}</Option>
                                                            ))}
                                                        </Select>
                                                    ) : null}
                                                </Form.Item>
                                                <Form.Item
                                                    label="Remarks"
                                                    name={`remarks_${index}`}
                                                    // initialValue={group.lab_followup_remark}
                                                    style={{ marginBottom: 0, minWidth: '400px' }}
                                                >
                                                    <Input
                                                        style={{ width: '100%' }}
                                                        placeholder="Remarks"
                                                        size="small"
                                                        onChange={(event) => handleChange(event.target.value, group, 'lab_followup_remark')}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </Form>
                                    }
                                    collapsible="icon"
                                >
                                    <TableComponent
                                        className="doctor-notes-lab-deatils"
                                        rowKey={(record, key) => key}
                                        pagination={false}
                                        // scroll={{ x: true }}
                                        dataSource={group.group_items}
                                        columns={labResultColumns}
                                    />
                                </Panel>
                            </Collapse>
                        </div>
                    ))}
                </>
            ) : (
                <>
                    <Card className="card-shadow card">
                        <div style={{ textAlign: 'center', padding: '20px' }}>No Data Found</div>
                    </Card>
                </>
            )}
        </div>
    );
}
